import styled from "styled-components";
export const Styles = styled.div`
  #activitiesSection {
    position: relative;
  }
  #activitiesSection .tag {
    position: absolute;
    height: 100px;
    bottom: 0;
  }
  #activitiesSection .semi-column {
    position: absolute;
    height: 200px;
    right: 50px;
  }
  #activitiesSection .circle-bg {
    position: absolute;
    top: 54%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    box-shadow: 0px 0px 100px var(--dark-purple);
  }
  #activitiesSection .swiper-slide {
    transform: scale(0.7) !important;
    padding-block: 30px;
    transition: 0.3s;
  }
  #activitiesSection .swiper-slide-active {
    transform: scale(1.1) !important;
  }
.activities-container{
  justify-content: center;
}
  @media (max-width: 992px) {
    #activitiesSection .circle-bg {
      top: 53%;
      left: 68%;
      transform: translate(-50%, -50%) scale(.8);
    }
    #activitiesSection .swiper-slide {
      padding-block: 0px;
      transform: scale(0.9) !important;
    }
    #activitiesSection .swiper-slide-active {
      transform: scale(0.9) !important;
    }
  }
  @media (max-width: 767px) {
    #activitiesSection .circle-bg {
      top: 54%;
      left: 50%;
      transform: translate(-50%, -50%) scale(.8);
    }
    #activitiesSection .tag {
      bottom: -75px;
    }
    #activitiesSection .semi-column {
      top: -75px;
      right: 85%;
    }
  }
`;
